/**
 * Device Storage API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { NetworkStatusTimespan } from './networkStatusTimespan';
import { DataPlanTimespan } from './dataPlanTimespan';
import { StringTimespan } from './stringTimespan';
import { LongTimespan } from './longTimespan';
import { ComProviderTimespan } from './comProviderTimespan';


export interface AirtimeDeviceDto { 
    comIdTimeline?: Array<StringTimespan>;
    comProviderTimeline?: Array<ComProviderTimespan>;
    comType?: AirtimeDeviceDto.ComTypeEnum;
    dataPlanTimeline?: Array<DataPlanTimespan>;
    deviceTypeId?: string;
    idDevice?: string;
    networkStatusTimeline?: Array<NetworkStatusTimespan>;
    paymentAccountTimeline?: Array<LongTimespan>;
}
export namespace AirtimeDeviceDto {
    export const ComTypeEnum = {
        Iridium: 'IRIDIUM',
        Globalstar: 'GLOBALSTAR',
        NbIot: 'NB_IOT',
        NoCommunication: 'NO_COMMUNICATION',
        Gsm: 'GSM'
    } as const;
    export type ComTypeEnum = typeof ComTypeEnum[keyof typeof ComTypeEnum];
}


export type ComTypeEnum = typeof AirtimeDeviceDto.ComTypeEnum[keyof typeof AirtimeDeviceDto.ComTypeEnum];
